//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    import Timepick from '@/components/tiemPick'
    import MipLightbox from '@/components/clinicToast/mipLightbox'
    import { Datetime } from 'vue-datetime';
    import 'vue-datetime/dist/vue-datetime.css'

    import {phoneReg } from '@/utils/regular.js'
    import {nameReg} from '@/utils/regular.js'
    import {IDcardReg} from '@/utils/regular.js'
``
    import {getUserinfo,insuraSubmit,insuraGatSubmit,progress} from '@/model/appointment/appointmentService';
    import { store, mutations } from "../store/store"; 
    import { store as observableStore } from "@/observable/store"
    export default { 
        name: "reservation-home",
        data(){
            return {
                appointment:'',
                hospitalFlag:false,//是否为二次预约就诊
                selectBtn:true,
                resName:'请选择预约门诊',
                address:'',
                templ:null,
                timeCode:null,
                nameGat:'', //关爱通姓名
                IDcardGat:'',
                gatCard:process.env.VUE_APP_GAT_CARD,

                // telPhone:null,
                // dataPhone:null,
                // name:null,
                // idCard:null,
                // uuid:null,
            }
        },
         components:{
            Datetime,
            Timepick,
            MipLightbox
        },
        computed: {
            outpatient(){
                return store.outpatient
            },
            appoinTime(){
                return store.appoinTime
            },
            updatePhone(){ //修改的手机号
                return store.updateTime
            },
            templateFlag(){
                return this.$route.query.templateFlag
            },
            gatCardFlag(){
                return this.$route.query.gatCardFlag
            }
        },
        watch: {
            outpatient(val){
                this.resName = this.outpatient.name;
                this.timeCode = this.outpatient.code
                this.address = this.outpatient.address
                this.bus.$emit("timeCodeFlag",this.timeCode);
                this.appointment = ''
                this.$emit('outpatientEmit',this.outpatient)
            },
            appointment(val){
                this.$emit('appointmentEmit',this.appointment)
            }
        },
        created() {
            // this.uuid = this.$route.query.uuid;
            this.templ = this.templateFlag
            if(this.resName != '请选择预约门诊' && this.appoinTime){
                this.appointment = this.appoinTime;
            }
          
        },
        mounted(){
            
           // 埋点
          this.STATISTICS('load','sybao_ins_make_appointment_page')
        },
        methods: {
            emitTime(msg){
                this.appointment = msg;
                // //console.log('5555',msg)
            },
            selectTiem(){
                //console.log('选择时间',this.timeCode)
                if(!this.timeCode){
                   this.$toast("请先填写门诊");
                   return;
                }
                this.$refs.tiemRef.showoast(this.timeCode)
            },
            
            clinic(){
                if(this.hospitalFlag){
                  return false;
                }
                this.$refs.mipLightbox.showToast()
            },
          
          
            // submitGatClick(){
                
            //     let data = {
            //             "code": this.timeCode, // 诊所编号
            //             "uuid": this.uuid,
            //             "phone": this.telPhone,
            //             'id_card':this.IDcardGat,
            //             'name':this.nameGat,
            //             'appointment_at':this.appointment
            //         }
            //      insuraGatSubmit(data).then(data=>{
            //         //console.log(data)
            //         if(data){
            //             this.$router.push({
            //                 path: "/reservationStatus",
            //                 query:{
            //                     uuid:this.uuid,
            //                     order_no:data.order_no,
            //                     templateFlag: this.templateFlag,
            //                     gatCardFlag:this.gatCardFlag,
            //                     entity:this.$route.query.entity

            //                 }
            //             });
            //         }
            //     }).catch(err=>{
            //         this.$toast(err.message);
            //     })
            // },

            // submitClick(){
            //       let data = {
            //             "code": this.timeCode, // 诊所编号
            //             "uuid": this.uuid,
            //             "phone": this.telPhone,
            //             'appointment_at':this.appointment
            //         }
            //      insuraSubmit(data).then(data=>{
            //         //console.log(data)
            //         if(data){
            //             this.$router.push({
            //                 path: "/reservationStatus",
            //                 query:{
            //                     uuid:this.uuid,
            //                     templateFlag: this.templateFlag,
            //                     order_no:data.order_no,
            //                     gatCardFlag:this.gatCardFlag,
            //                     entity:this.$route.query.entity

            //                 }
            //             });
            //         }
            //     }).catch(err=>{
            //         this.$toast(err.messgae);
            //     })
            // },
            // foucsTime(){
            //     document.querySelector('.outpatient-info').focus()
            // },
        },
    }
